export { default } from "bullitttime-embercomponents/components/courses-card";
